import React from 'react';
import './DashboardEdit.css';

const DashboardEdit = ({ isOpen, onClose, config, onConfigChange }) => {
  if (!isOpen) return null;

  return (
    <div className="dashboard-edit-overlay">
      <div className="dashboard-edit-popup">
        <div className="dashboard-edit-header">
          <h2>Personalizar Dashboard</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="dashboard-edit-content">
          <div className="edit-option">
            <label>
              <input
                type="checkbox"
                checked={config.showPomodoro}
                onChange={(e) => onConfigChange({
                  ...config,
                  showPomodoro: e.target.checked
                })}
              />
              Mostrar Pomodoro
            </label>
          </div>
          <div className="edit-option">
            <label>
              <input
                type="checkbox"
                checked={config.showTasks}
                onChange={(e) => onConfigChange({
                  ...config,
                  showTasks: e.target.checked
                })}
              />
              Mostrar Lista de Tareas
            </label>
          </div>
          <div className="edit-option">
            <label>
              <input
                type="checkbox"
                checked={config.showCalendar}
                onChange={(e) => onConfigChange({
                  ...config,
                  showCalendar: e.target.checked
                })}
              />
              Mostrar Calendario
            </label>
          </div>
          <div className="edit-option">
            <label>
              <input
                type="checkbox"
                checked={config.showAnaliticas}
                onChange={e => onConfigChange({
                  ...config,
                  showAnaliticas: e.target.checked
                })}
              />
              Mostrar Analíticas
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardEdit;